import { CheckoutSessionProvider } from "@circle-react/components/Paywalls/Checkout/contexts/CheckoutSessionContext";
import { useCheckoutSessionRouteParams } from "@circle-react/components/Paywalls/CheckoutWithSession/hooks/useCheckoutSessionRouteParams";
import { OfferRoute } from "@circle-react/components/Paywalls/CheckoutWithSession/routes/OfferRoute";
import { rootRoute } from "@circle-react/routes/PaywallCheckout/tanstack_routes/__root";
import { createRoute } from "@tanstack/react-router";

export const offerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/checkout/$checkoutPath/step/$stepId",
  component: Offer,
});

function Offer() {
  const { paywallId } = offerRoute.useRouteContext();
  const { paymentValidationParams, sessionId, stepId } =
    useCheckoutSessionRouteParams();

  return (
    <CheckoutSessionProvider
      paywallId={paywallId}
      sessionId={sessionId}
      stepId={stepId}
      paymentValidationParams={paymentValidationParams}
    >
      <OfferRoute />
    </CheckoutSessionProvider>
  );
}
